const isAndroid = (): boolean => {
       return /(android)/i.test(navigator.userAgent);
    }

export default isAndroid